// @ts-nocheck

import { useSelector } from 'react-redux'
import { ReduxState } from '../../../redux/rootReducer'
import { PaymentMethod } from './PaymentMethod/PaymentMethod'
import { OrderProcess } from './OrderProcess/OrderProcess'
import { CreditCard } from './CreditCard/CreditCard'
import { AddressDesktop } from './Address/Desktop/AddressDesktop'
import { UpdateDocument } from './Document/UpdateDocument'
import { Pix } from './Pix/Pix'
import { useEffect } from 'react'
import cpfValidate from '../../../utils/cpfValidator'

export const Checkout = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const { step } = useSelector(
    (state: ReduxState) => state.CheckoutReducer.data
  )

  const { address, email, document } = useSelector(
    (state: ReduxState) => state.UserReducer
  )

  const hasIncompleteAddress =
    email !== '' &&
    (address?.number === null ||
      address?.zipCode === null ||
      address?.street === null)

  const hasMissingDocument = email !== '' && !cpfValidate(document || '')

  switch (step) {
    case 'pix':
      return <Pix />
    case 'creditCard':
      return <CreditCard />
    case 'defaultCheckout':
      if (hasIncompleteAddress) {
        return <AddressDesktop />
      }
      if (hasMissingDocument) {
        return <UpdateDocument />
      }
      return <PaymentMethod />
    case 'paymentSuccess':
      return <OrderProcess />
    default:
      return <PaymentMethod />
  }
}
